import { Dialog, DialogActions, DialogContent } from "@mui/material";
import { DialogHeader } from "../../../auth/components/DialogHeader";
import { useContext, useState } from "react";
import { MainContext } from "../../../main/context/MainContextProvider";
import DangerBaseButton from "../../../main/components/DangerBaseButton";
import BaseButton from "../../../main/components/BaseButton";
import ConfirmationDialog from "../../alarms/components/ConfirmationDialog";
import { ConfirmationModal } from "../../../main/components/ConfirmationModal";
import { SuccessModal } from "../../../main/components/SuccessModal";
import { ActionAlert } from "../../../main/components/alerts/ActionAlert";
import { postCreateCalled } from "../../../services/api/routes/calleds";
import { Called, calledCategoryToString } from "../../calleds/types";
import NewCalledForm from "./NewCalledForm";

type AddFileModalProps = {
    open: boolean;
    onCancel: () => void;
    onClose: () => void;
};

export const NewCalledModal: React.FC<AddFileModalProps> = ({
    open,
    onCancel,
    onClose
}) => {
    const { theme, user } = useContext(MainContext);
    const primary = theme.muiTheme.palette.primary.main;

    const [isCancelConfirmationOpen, setCancelConfirmationOpen] = useState(false);
    const [isSaveConfirmationOpen, setSaveConfirmationOpen] = useState(false);
    const [openSuccessModal, setOpenSuccessModal] = useState(false);
    const [openErrorModal, setOpenErrorModal] = useState(false);
    const [calledResponse, setCalledResponse] = useState<Called>();
    const [loading, setLoading] = useState(false);

    const [data, setData] = useState<{
        descricao?: string;
        category?: number;
        files?: File[];
    }>({
        descricao: undefined,
        category: undefined,
        files: undefined
    });

    const handleSaveClick = () => {
        setSaveConfirmationOpen(true);
    };

    const handleSave = async () => {
        setLoading(true);
        const category = data.category ?? 0;
        const postData = {
            descricao: data.descricao ?? "",
            category: category ? category : undefined,
            anexos: data.files ? data.files : undefined
        };
        const response = await postCreateCalled(
            user?.name ?? "",
            user?.email ?? "",
            postData.category ? postData.category : 0,
            postData.descricao,
            postData.anexos
        )

        setCalledResponse(response);
        setData({
            descricao: undefined,
            category: undefined,
            files: undefined
        });
        setSaveConfirmationOpen(false);
        setOpenSuccessModal(true);
        setLoading(false);
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                aria-labelledby="customized-dialog-title"

            >
                <DialogHeader id="customized-dialog-title" onClose={onClose}>
                    Abertura de chamado
                </DialogHeader>
                <DialogContent
                    sx={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                    dividers
                >
                    <NewCalledForm data={data} setData={setData} />
                </DialogContent>
                <DialogActions>
                    <DangerBaseButton onClick={onCancel} title="Cancelar" />
                    <BaseButton
                        disabled={loading}
                        sx={{
                            backGroundColor: primary,
                            borderColor: primary,
                            height: "34px",
                            width: "95px",
                            "& .MuiTypography-root": {
                                color: primary,
                            },
                            "&:hover": {
                                borderColor: primary,
                                backgroundColor: primary,
                                color: primary,
                                "& .MuiTypography-root": {
                                    color: "#FFFFFF",
                                },
                            },
                        }}
                        onClick={handleSaveClick}
                        title="Salvar"
                    />
                </DialogActions>
            </Dialog>
            <ConfirmationDialog
                open={isCancelConfirmationOpen}
                title="Descartar cadastro"
                message="Deseja cancelar o cadastro da chamado?"
                onConfirm={onClose}
                onCancel={() => setCancelConfirmationOpen(false)}
                onClose={() => setCancelConfirmationOpen(false)}
            />

            <ConfirmationModal
                open={isSaveConfirmationOpen}
                setOpen={() => setSaveConfirmationOpen(false)}
                title="Cadastrar Chamado"
                contentText="Deseja confirmar o cadastro deste chamado?"
                onConfirm={() => handleSave()}
                setOpenErrorModal={setOpenErrorModal}
                setOpenSuccessModal={setOpenSuccessModal}

            />

            <SuccessModal
                contentText={`O chamado [#${calledResponse?.code}][${calledCategoryToString(calledResponse?.categoria)}] foi cadastrado com sucesso!`}
                title="Cadastro realizado!"
                open={openSuccessModal}
                setOpen={() => { setOpenSuccessModal(false); setLoading(false) }}
                onClose={onClose}
            />

            <ActionAlert
                message="Ocorreu um erro ao cadastrar o chamado! Tente novamente mais tarde."
                severity="error"
                open={openErrorModal}
                setOpen={setOpenErrorModal}
                onClose={() => { setSaveConfirmationOpen(false); setLoading(false) }}
            />
        </>
    )
}